<template>
  <v-layout column>
    <v-layout
      align-center
      class="title"
      style="cursor: pointer"
      @click="goHome()"
    >
      <v-layout column align-center class="px-3">
        <img v-if="firmLogo" :src="firmLogo" class="logo" />
        <img v-else src="@/assets/logo.png" class="logo" />
      </v-layout>
    </v-layout>
    <v-list
      class="mt-4 px-3"
      :class="{ toolbar__menu: $vuetify.breakpoint.smAndDown }"
    >
      <v-list-tile
        v-if="isAdvisor"
        class="grey--text text--darken-1"
        @click="$router.push('/overview')"
      >
        <v-tooltip right>
          <v-list-tile-action slot="activator">
            <v-layout align-center>
              <i class="material-icons-outlined option__icon mr-2"
                >border_all</i
              >
              <div class="menu_text">Overview</div>
            </v-layout>
          </v-list-tile-action>
          <span
            >Shortcut
            <div class="shortcut-key">Ctrl/Cmd + h</div></span
          >
        </v-tooltip>
      </v-list-tile>
      <v-divider v-if="isAdvisor" class="mx-2 my-2" />
      <v-list-tile
        v-for="item in navigationItems"
        v-if="(item.auth && isAdvisor) || !item.auth"
        :key="item.title"
        @click="item.path == '#' ? '' : $router.push(item.path)"
        :exact="item.exact"
        class="grey--text text--darken-1"
      >
        <v-tooltip right>
          <v-list-tile-action slot="activator">
            <v-layout :id="item.id" align-center>
              <i
                :class="$route.name === item.name ? 'black--text' : ''"
                class="material-icons-outlined option__icon mr-2"
                >{{ item.icon }}</i
              >
              <div
                :class="
                  $route.name === item.name
                    ? 'black--text font-weight-bold'
                    : ''
                "
                class="menu_text"
              >
                {{ item.name ? $t('sidebar.' + item.name) : item.title }}
              </div>
            </v-layout>
          </v-list-tile-action>
          <span
            >Shortcut: Next Tab
            <div class="shortcut-key">Tab</div></span
          >
        </v-tooltip>
      </v-list-tile>
    </v-list>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import endsWith from 'lodash/endsWith';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'TheNavigation',
  data() {
    return {
      number: 0,
    };
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'isAdvisor',
      'navigationItems',
      'user',
      'currentFirm',
    ]),
    firmLogo() {
      if (this.currentFirm.medium_url) {
        return this.currentFirm.medium_url;
      }
    },
  },
  methods: {
    isEmpty,
    logout() {
      this.$store.dispatch('userSignOut');
    },
    endsWith,
    goHome() {
      if (this.user.is_advisor) {
        this.$router.push('/overview').catch(() => {});
      } else {
        this.$router.push('/').catch(() => {});
      }
    },
  },
};
</script>
<style lang="css">
.toolbar__menu {
  width: 50px;
}
.option__icon {
  font-size: 18px;
}
.menu_text {
  font-size: 15px;
}
.logo__text {
  font-weight: 600;
  font-size: 22px;
}
</style>
